import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl +'/system' 

export default {
	/**
	 * 获取项目列表
	**/
	getProject(params){
		params = commonJs.obj.removeNullKey(params)
		return request({
			url: BASE_URL+'/project',
			method:'get',
			params
		})
	},

	/**
	 * 添加项目
	**/
    projectAdd(data) {
		return request({
		url: BASE_URL+'/project',
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 修改项目
	**/
	projectEdit(id,data){
		return request({
			url: BASE_URL+'/project/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 删除项目
	**/
	projectDel(id){
		return request({
			url: BASE_URL+'/project/'+id,
			method:'DELETE'
		})
	}
}